var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5.5C3.44772 5.5 3 5.94772 3 6.5C3 7.05228 3.44772 7.5 4 7.5H20C20.5523 7.5 21 7.05228 21 6.5C21 5.94772 20.5523 5.5 20 5.5H4ZM3 12.5C3 11.9477 3.44772 11.5 4 11.5C4 11.5 13.7516 11.5 20 11.5C20.5523 11.5 21 11.9477 21 12.5C21 13.0523 20.5523 13.5 20 13.5H4C3.44772 13.5 3 13.0523 3 12.5ZM3.13647 18.5C3.13647 17.9477 3.58419 17.5 4.13647 17.5H20C20.5523 17.5 21 17.9477 21 18.5C21 19.0523 20.5523 19.5 20 19.5H4.13647C3.58419 19.5 3.13647 19.0523 3.13647 18.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.bd9cdb123bfd658d2b0731b96c73854f.svg";
export { ForwardRef as ReactComponent };